'use strict';

/* Directives */


angular.module('FlexyBeautyApp.directives')
    .directive('jqueryEditor', ["$sce",function($sce) {
        return {
            restrict: 'A',
            require: '^ngModel',
            link: function (scope, element, attrs, ngModel) {
                $(function () {
                    element.jqte({
                        br: false,
                        justify:false,
                        center:false,
                        format : false,
                        indent : false,
                        outdent : false,
                        color:false,
                        link:false,
                        left:false,
                        ol:false,
                        p:false,
                        right:false,
                        rule:false,
                        source:false,
                        sup:false,
                        sub:false,
                        strike:false,
                        ul:false,
                        unlink:false,
                        fsize:true,
                        fsizes:["40","45","50","55","60"],

                        // On change refresh the model with the textarea value
                        change: function () {
                            if (scope.$root)
                            {
                                var safeHtml = $sce.trustAsHtml(element.parents(".jqte").find(".jqte_editor")[0].innerHTML);
                                var phase = scope.$root.$$phase;
                                if(phase == '$apply' || phase == '$digest')
                                    ngModel.$setViewValue(safeHtml);
                            else
                                    scope.$apply(function () {
                                        ngModel.$setViewValue(safeHtml);
                                        });
                            }
                            else
                                ngModel.$setViewValue(safeHtml);

                        }
                    });
                });

                // On render refresh the textarea with the model value
                ngModel.$render = function () {
                    element.parents(".jqte").find(".jqte_editor")[0].innerHTML = ngModel.$viewValue || '';
                };
            }
        }
    }]).directive('colorPicker', ["$parse", function($parse) {
        return {
            restrict: 'A',

            require: '^ngModel',
            link: function(scope, element, attrs,ngModel) {
                var ngModelGet = $parse(attrs.ngModel);
                var defaultValue = "";
                if (ngModelGet && ngModelGet(scope))
                    defaultValue = ngModelGet(scope);


                $(element).spectrum({
                    allowEmpty:true,
                    color: defaultValue,
                    showInput: true,
                    containerClassName: "full-spectrum",
                    showInitial: true,
                    showPalette: true,
                    showSelectionPalette: true,
                    chooseText: "Fermer",
                    cancelText: "",
                    maxPaletteSize: 10,
                    preferredFormat: "hex",
                    move: function (color) {
                        if (color!==undefined)
                        {
                            if (color)
                                ngModel.$setViewValue( color.toHexString());
                            else
                                ngModel.$setViewValue( null);
                            if(scope.$root && scope.$root.$$phase != '$apply' && scope.$root.$$phase!= '$digest') // not apply running
                                scope.$apply();
                        }
                    },
                    show: function () {

                    },
                    beforeShow: function () {

                    },
                    hide: function (color) {

                    },

                    palette: [
                        ["rgb(0, 0, 0)", "rgb(67, 67, 67)", "rgb(102, 102, 102)", "rgb(153, 153, 153)","rgb(183, 183, 183)",
                            "rgb(204, 204, 204)", "rgb(217, 217, 217)", "rgb(239, 239, 239)", "rgb(243, 243, 243)", "rgb(255, 255, 255)"],
                        ["rgb(152, 0, 0)", "rgb(255, 0, 0)", "rgb(255, 153, 0)", "rgb(255, 255, 0)", "rgb(0, 255, 0)",
                            "rgb(0, 255, 255)", "rgb(74, 134, 232)", "rgb(0, 0, 255)", "rgb(153, 0, 255)", "rgb(255, 0, 255)"],
                        ["rgb(230, 184, 175)", "rgb(244, 204, 204)", "rgb(252, 229, 205)", "rgb(255, 242, 204)", "rgb(217, 234, 211)",
                            "rgb(208, 224, 227)", "rgb(201, 218, 248)", "rgb(207, 226, 243)", "rgb(217, 210, 233)", "rgb(234, 209, 220)",
                            "rgb(221, 126, 107)", "rgb(234, 153, 153)", "rgb(249, 203, 156)", "rgb(255, 229, 153)", "rgb(182, 215, 168)",
                            "rgb(162, 196, 201)", "rgb(164, 194, 244)", "rgb(159, 197, 232)", "rgb(180, 167, 214)", "rgb(213, 166, 189)",
                            "rgb(204, 65, 37)", "rgb(224, 102, 102)", "rgb(246, 178, 107)", "rgb(255, 217, 102)", "rgb(147, 196, 125)",
                            "rgb(118, 165, 175)", "rgb(109, 158, 235)", "rgb(111, 168, 220)", "rgb(142, 124, 195)", "rgb(194, 123, 160)",
                            "rgb(166, 28, 0)", "rgb(204, 0, 0)", "rgb(230, 145, 56)", "rgb(241, 194, 50)", "rgb(106, 168, 79)",
                            "rgb(69, 129, 142)", "rgb(60, 120, 216)", "rgb(61, 133, 198)", "rgb(103, 78, 167)", "rgb(166, 77, 121)",
                            "rgb(133, 32, 12)", "rgb(153, 0, 0)", "rgb(180, 95, 6)", "rgb(191, 144, 0)", "rgb(56, 118, 29)",
                             "rgb(19, 79, 92)", "rgb(17, 85, 204)", "rgb(11, 83, 148)", "rgb(53, 28, 117)", "rgb(116, 27, 71)",
                            "rgb(91, 15, 0)", "rgb(102, 0, 0)", "rgb(120, 63, 4)", "rgb(127, 96, 0)", "rgb(39, 78, 19)",
                            "rgb(12, 52, 61)", "rgb(28, 69, 135)", "rgb(7, 55, 99)", "rgb(32, 18, 77)", "rgb(76, 17, 48)"]
                    ]
                });

                scope.$watch(attrs.ngModel, function (newValue,oldValue) {
                    if (newValue!=oldValue)
                        $(element).spectrum("set",ngModelGet(scope));
                });
            }
        };
    }]).directive('jqueryuiSpinner', ["$parse", function($parse) {
        return {
            restrict: 'A',
            require: '^ngModel',
            scope: {
                jqueryuiSpinnerDisabled:'='
            },
            link: function(scope, element, attrs,ngModel) {
                var ngModelGet = $parse(attrs.ngModel);
                var spinnerVal = attrs.jqueryuiSpinner;
                var spinnerStepAttr = attrs.jqueryuiSpinnerStep;
                var spinnerMaxAttr = attrs.jqueryuiSpinnerMax;
                var spinnerDisabledAttr = scope.jqueryuiSpinnerDisabled;
                var spinnerMinAttr = attrs.jqueryuiSpinnerMin;

                var spinnerMin = 0;
                if (spinnerMinAttr!==undefined)
                    spinnerMin = parseInt(spinnerMinAttr);
                var spinnerDisabled = false;
                if (spinnerDisabledAttr!==undefined)
                    spinnerDisabled = spinnerDisabledAttr;
                var spinnerStep = 5;
                if (spinnerStepAttr!==undefined)
                    spinnerStep = parseInt(spinnerStepAttr);
                var spinnerMax = null;
                if (spinnerMaxAttr!==undefined)
                    spinnerMax = parseInt(spinnerMaxAttr);
                var defaultValue = "";
                if (ngModelGet && ngModelGet(scope))
                    defaultValue = ngModelGet(scope);
                $(element).spinner({
                    culture: "fr-FR",
                    step: spinnerStep,
                    min:spinnerMin,
                    max:spinnerMax,
                    numberFormat : spinnerVal,
                    disabled : spinnerDisabled,
                    change: function( event, ui )
                    {
                        var value = $(element).spinner("value");
                        ngModel.$setViewValue( value);
                        if(scope.$root && scope.$root.$$phase != '$apply' && scope.$root.$$phase!= '$digest') // not apply running
                            scope.$apply();
                    },
                    spin: function( event, ui )
                    {
                        ngModel.$setViewValue( ui.value);
                        if(scope.$root && scope.$root.$$phase != '$apply' && scope.$root.$$phase!= '$digest') // not apply running
                            scope.$apply();
                    }
                });
                $(element).spinner("value",defaultValue);
            }
        };
    }]).directive('jqueryuiSlider', ["$parse", function($parse) {
        return {
            restrict: 'A',
            require: '^ngModel',
            link: function(scope, element, attrs,ngModel) {
                var ngModelGet = $parse(attrs.ngModel);
                var defaultValue = 0;
                if (ngModelGet && ngModelGet(scope) && ngModelGet(scope)!==undefined)
                    defaultValue = ngModelGet(scope);
                var expressionHandler = null;
                if (attrs.jqueryuiSlider)
                    expressionHandler = $parse(attrs.jqueryuiSlider);
                var sliderStepAttr = 1;
                var sliderMaxAttrGet = $parse(attrs.jqueryuiSliderMax);
                var sliderMinAttrGet = $parse(attrs.jqueryuiSliderMin);
                var sliderStepAttrGet = $parse(attrs.jqueryuiSliderStep);
                var sliderRangeAttrGet = $parse(attrs.jqueryuiSliderRange);
                var sliderMaxAttr = null;
                var sliderMinAttr = 0;
                var sliderRangeAttr = true;
                if (sliderMaxAttrGet && sliderMaxAttrGet(scope)!==undefined && sliderMaxAttrGet(scope))
                    sliderMaxAttr = sliderMaxAttrGet(scope);
                if (sliderMinAttrGet && sliderMinAttrGet(scope)!==undefined && sliderMinAttrGet(scope))
                    sliderMinAttr = sliderMinAttrGet(scope);
                if (sliderStepAttrGet && sliderStepAttrGet(scope)!==undefined && sliderStepAttrGet(scope))
                    sliderStepAttr = sliderStepAttrGet(scope);
                if (sliderRangeAttrGet && sliderRangeAttrGet(scope)!==undefined)
                    sliderRangeAttr = sliderRangeAttrGet(scope);

                if (sliderRangeAttr) {
                    if (defaultValue!=null)
                        $(element).slider({
                            range: true,
                            min: sliderMinAttr,
                            max: sliderMaxAttr,
                            values: defaultValue,
                            step: sliderStepAttr,
                            slide: function (event, ui) {
                                ngModel.$setViewValue(ui.values);
                                if (scope.$root && scope.$root.$$phase != '$apply' && scope.$root.$$phase != '$digest') // not apply running
                                    scope.$apply();
                            },
                            stop: function (event, ui) {
                                if (expressionHandler && expressionHandler != undefined)
                                    scope.$apply(expressionHandler);
                            }
                        });
                    scope.$watch(attrs.ngModel, function (newValue, oldValue) {
                        if (newValue != oldValue)
                            $(element).slider("values", ngModelGet(scope));
                    });
                }
                else{
                    if (defaultValue!=null)
                        $(element).slider({
                            range: false,
                            min: sliderMinAttr,
                            max: sliderMaxAttr,
                            value: defaultValue,
                            step: sliderStepAttr,
                            slide: function (event, ui) {
                                ngModel.$setViewValue(ui.value);
                                if (scope.$root && scope.$root.$$phase != '$apply' && scope.$root.$$phase != '$digest') // not apply running
                                    scope.$apply();
                            },
                            stop: function (event, ui) {
                                if (expressionHandler && expressionHandler != undefined)
                                    scope.$apply(expressionHandler);
                            }
                        });
                    scope.$watch(attrs.ngModel, function (newValue, oldValue) {
                        if (newValue != oldValue)
                            $(element).slider("value", ngModelGet(scope));
                    });
                }
                //$(element).spinner("value",defaultValue);
            }
        };
    }]);




// WEBPACK FOOTER //
// ./js/directives/directivesApi.js